<template>
    <div id="container" class="container">
        <myheader2></myheader2>
        <div class="main-page-outer min-width">
            <div class="mx1360 main-count2 flex-r">
                <div class="left-cont">
                    <centerNavBar name="个人信息"></centerNavBar>
                </div>
                <div class="right-cont">
                    <div class="userinfo-box">
						<div class="title">
							<div class="t">完善个人信息</div>
							<div class="t2">根据环太湖动产登记备案综合服务平台相关要求，您需要进一步完善个人基本信息，平台认证通过后，可以正常进行作品备案登记。</div>
						</div>
						<div class="info-box">
								<personalForm @personal="personal"></personalForm>
						</div>
					</div>
                </div>

            </div>
        </div>
        <myfooter2></myfooter2>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js"
import personalForm from "@/components/personal/form.vue"
export default {
    name: "userinfo",
	components:{
		personalForm
	},
    data() {
        return {
            
        }
    },
    created() {
        
    },
    mounted() {
    },
    methods: {
		personal(){
			
		},
    },
};
</script>

<style lang="scss">
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用
@import './userinfo.scss';
</style>